import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import axios from "axios";
import { FaCheck } from "react-icons/fa";
import ReactModal from "react-modal";
import ActualizaRespuesta from "./ActualizaRespuesta";
import Cookies from "universal-cookie";
import VehiculoResultados from "./VehiculoResultados";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useParams } from "react-router-dom";

const Resultados = (props) => {
  let { idOrden } = useParams();
  let { idVehiculo } = useParams();
  const cookie = new Cookies();
  const [list1, setList1] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [vehicleInfo, setVehicleInfo] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true); // Estado de carga

  const respuestasEndpoint = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerRespuestas/${idOrden}`;
  const vehiculosEndpoint = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerVehiculos/${idVehiculo}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Ejecuta ambas peticiones de manera concurrente
        const [respuestasResponse, vehiculosResponse] = await Promise.all([
          axios({
            method: "get",
            url: respuestasEndpoint,
            auth: {
              username: process.env.REACT_APP_API_USERNAME,
              password: process.env.REACT_APP_API_PASSWORD,
            },
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          }),
          axios({
            method: "get",
            url: vehiculosEndpoint,
            auth: {
              username: process.env.REACT_APP_API_USERNAME,
              password: process.env.REACT_APP_API_PASSWORD,
            },
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          }),
        ]);

        setList1(respuestasResponse.data);

        if (vehiculosResponse.data && vehiculosResponse.data.length > 0) {
          const vehicleData = vehiculosResponse.data[0];
          setVehicleInfo({
            placa: vehicleData.v.placa,
            vin: vehicleData.v.vin || "N/A",
            marca: vehicleData.marca,
            modelo: vehicleData.v.modelo,
            tipoVehiculo: vehicleData.v.tipoVehiculo,
          });
        } else {
          setError("No vehicle data found.");
        }

        // Cambia el estado de carga cuando ambas peticiones se resuelvan
        setLoading(false);
      } catch (err) {
        setError("Error fetching data. Please try again.");
        setLoading(false);
        console.error(err);
      }
    };

    fetchData();
  }, [respuestasEndpoint, vehiculosEndpoint]);

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list1.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(list1.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const generatePDF = () => {
    window.location.href = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/InformeResultados/${idOrden}`;
  };
  const Volver = () => {
    window.location.href = `/admin/OrdenesHisorico`;
  };

  return (
    <>
      {loading ? (
        <div>Loading...</div> // Mostrar mensaje de carga mientras se obtienen los datos
      ) : (
        <>
          {error && <div className="alert alert-danger">{error}</div>}

          <Header />
          <Container className="mt--7" fluid>
            <VehiculoResultados vehiculoId={idVehiculo} />
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">
                      Resultados de la lista de verificación
                    </h3>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Numeral</th>
                        <th scope="col">Respuesta</th>
                        {cookie.get("tipoUsuarioId") === "1" ? (
                          <th scope="col">Editar</th>
                        ) : (
                          <th></th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item) => (
                        <tr key={item.id}>
                          <td>{item.descripcion}</td>
                          <td>{item.respuesta}</td>
                          {cookie.get("tipoUsuarioId") === "1" ? (
                            <td>
                              <ActualizaRespuesta id={item.id} />
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <CardFooter className="py-4">
                    <Row>
                      <Col md="2">N°Resgistros</Col>
                      <Col md="3">
                        <FormGroup>
                          <Input
                            type="select"
                            id="itemsPerPageSelect"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="7">
                        <nav aria-label="...">
                          <Pagination className="pagination justify-content-end mb-0">
                            <PaginationItem disabled={currentPage === 1}>
                              <PaginationLink
                                onClick={() => paginate(currentPage - 1)}
                              >
                                <i className="fas fa-angle-left" />
                                <span className="sr-only">Previous</span>
                              </PaginationLink>
                            </PaginationItem>
                            {Array.from({ length: totalPages }, (_, index) => (
                              <PaginationItem
                                active={index + 1 === currentPage}
                                key={index + 1}
                              >
                                <PaginationLink
                                  onClick={() => paginate(index + 1)}
                                >
                                  {index + 1}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                            <PaginationItem
                              disabled={currentPage === totalPages}
                            >
                              <PaginationLink
                                onClick={() => paginate(currentPage + 1)}
                              >
                                <i className="fas fa-angle-right" />
                                <span className="sr-only">Next</span>
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </nav>
                      </Col>
                    </Row>
                  </CardFooter>
                </Card>
              </div>
            </Row>
            <Button color="primary" onClick={Volver} title="Descargar Reporte">
              Volver
            </Button>
            <Button
              color="danger"
              onClick={generatePDF}
              title="Descargar Reporte"
            >
              Descargar PDF
            </Button>
          </Container>
        </>
      )}
    </>
  );
};

export default Resultados;
